/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    PAYMENTS_title: "Payments",
    PAYMENTS_label: "payment",
    PAYMENTS_plural_label: "payments",

    PAYMENTS_columnTotal: "Total",
    PAYMENTS_columnFrequency: "Frequency",
    PAYMENTS_columnNumber: "Invoice number",
    PAYMENTS_columnCustomerName: "Customer name",
    PAYMENTS_columnCustomerEmail: "Customer email",
    PAYMENTS_columnDueDate: "Due date",
    PAYMENTS_columnCreatedAt: "Created date",

    PAYMENTS_frequencyMonthly: "Monthly",
    PAYMENTS_frequencyYearly: "Yearly",

    PAYMENTS_statusSucceeded: "Succeeded",
    PAYMENTS_statusProcessing: "Processing",
    PAYMENTS_statusIncomplete: "Incomplete",
    PAYMENTS_statusCanceled: "Canceled",

    PAYMENTS_filterName: "Customer name",
    PAYMENTS_filterNamePlaceholder: "Filter by customer name",
    PAYMENTS_filterStatus: "Status",
    PAYMENTS_filterStatusPlaceholder: "Filter by status",

    PAYMENTS_statusPaid: "Paid",
    PAYMENTS_statusOpen: "Pending",
    PAYMENTS_statusUncollectible: "Unpaid",
    PAYMENTS_statusVoid: "Voided",
    PAYMENTS_statusRejected: "Rejected",

    PAYMENTS_noCustomerLinked: "No customer linked to this payment.",

    PAYMENTS_splashScreenTitle: "No invoices",
    PAYMENTS_splashScreenDescription: "Your customers' invoices will appear here."
};
